/**
 * @generated SignedSource<<595caa62ed91ebd42d50d43831ceaadd>>
 * @relayHash 7f18f12ced63781f3224bd8aee143c4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd1286c0b9918a731581674e0d42c17e57d6cb7e6d20278451a09df4d6cc05d4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { LinkedGoalsQuery } from './LinkedGoalsQuery.graphql';

const node: PreloadableConcreteRequest<LinkedGoalsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bd1286c0b9918a731581674e0d42c17e57d6cb7e6d20278451a09df4d6cc05d4",
    "metadata": {},
    "name": "LinkedGoalsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
